import "@/config/env";
import "@/lib/i18n";

import { loadSentry } from "@nablax/shared/lib";
loadSentry();

import { createRoot } from "react-dom/client";

import { App } from "./app";
import "./index.css";

const root = document.getElementById("root");
if (!root) throw new Error("root: no root element found");

// promise.then(() =>
createRoot(root).render(<App />);
// );
